//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ReceiptEmailType } from './Enums';

export class TransactionReceiptEmailRenderInputItem extends ItemBase {
    RecipientParentID: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Amount: number = 0;
    Description: string | null = null;
    PaymentMethod: string | null = null;
    EmailType: ReceiptEmailType = ReceiptEmailType.Payment;

    constructor(initializer?: Partial<TransactionReceiptEmailRenderInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TransactionReceiptEmailRenderInputItem";
}
